import update from "immutability-helper";
import _ from "lodash";

// Constants
export const NAME = "portfolioReview";
export const SET_SELECTED_COURSE_ID = "SET_SELECTED_COURSE_ID " + NAME;

// Actions creators

export const setSelectedCourseId = courseId => {
  return {
    type: SET_SELECTED_COURSE_ID,
    payload: courseId,
  };
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [SET_SELECTED_COURSE_ID]: (state, action) => {
    return update(state, {
      selectedCourseId: { $set: action.payload },
    });
  },
};

export const getReviewAllowedCurriculumProgramIds = (
  configurationData = []
) => {
  return _.reduce(
    configurationData,
    (result, configResponse) => {
      const config = _.get(configResponse, "configurations[0]", {});
      const value = JSON.parse(_.get(config, "value", "[]"));

      if (_.includes(value, "REVIEW")) {
        const curriculumProgramGroup = _.find(
          _.get(configResponse, "entityGroups", []),
          { entityType: "CURRICULUM_PROGRAM" }
        );
        if (curriculumProgramGroup) {
          result.push(curriculumProgramGroup.entityId);
        }
      }

      return result;
    },
    []
  );
};

export const formatCongigurationInput = ({
  curriculumProgramIds = [],
  userId,
}) => {
  return _.map(curriculumProgramIds, curriculumProgramId => ({
    configurationEntityGroups: [
      {
        entityId: curriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
      {
        entityId: userId,
        entityType: "USER",
      },
    ],
    configurationGroups: ["StaffPermission"],
    excludeInterRepoConfigurations: true,
    configurations: ["StaffPermission:PortfolioReviewer"],
  }));
};

// Initial State and export Reducer
const initialState = {
  selectedCourseId: null,
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
